import React from "react";
import { useNavigate } from "react-router-dom";
import { PATH_CART } from "@routes";
import styled from "styled-components";
import { StyledButton } from "@components";

interface RedirectToCartProps {
    open: boolean;
    onClose: () => void;
}

export const RedirectToCart: React.FC<RedirectToCartProps> = ({ open, onClose }) => {
    const navigate = useNavigate();

    const handleYes = () => {
        onClose();
        navigate(PATH_CART);
    };
    const handleNo = () => {
        onClose();
    };

    return open ? (
        <StyledOverlay>
            <StyledModalContent>
                <StyledQuestionText>Would you like to view your cart now?</StyledQuestionText>
                <StyledButtonContainer>
                    <StyledButton $borderRadius="4px" color={["#436CB2 0%", "#28B7C3 100%"]} onClick={handleYes}>
                        Yes
                    </StyledButton>
                    <StyledButton $borderRadius="4px" color="#6e7375" onClick={handleNo}>
                        No
                    </StyledButton>
                </StyledButtonContainer>
            </StyledModalContent>
        </StyledOverlay>
    ) : null;
};

const StyledOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 3;
`;

const StyledModalContent = styled.div`
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
`;

const StyledQuestionText = styled.p`
    font-size: 16px;
`;

const StyledButtonContainer = styled.div`
    display: flex;
    gap: 10px;
    justify-content: center;
`;
